import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";

import HomePage from "@/pages/HomePage";
import SellerPage from "@/pages/SellerPage";
import BuyerPage from "@/pages/BuyerPage";
import MarktWertPage from "@/pages/MarktWertPage";
import KontaktPage from "@/pages/KontaktPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import SeoPage from "@/pages/SeoPage";
import DistrictPage from "@/pages/DistrictPage";
import FaqArticlePage from "@/pages/FaqArticlePage";
import BuyerDistrictPage from "@/pages/BuyerDistrictPage";
import ImmobilienpreisePage from "@/pages/ImmobilienpreisePage";
import AdminPage from "@/pages/AdminPage";
import LifeEventPage from "@/pages/LifeEventPage";
import RatgeberPage from "@/pages/RatgeberPage";
import BlogPage from "@/pages/BlogPage";
import BlogArticlePage from "@/pages/BlogArticlePage";
import ObjektePage from "@/pages/ObjektePage";
import ObjekteDetailPage from "@/pages/ObjekteDetailPage";

import { seoPageConfigs, districtConfigs } from "@/config/seoConfigs";
import { extendedSeoConfigs, buyerDistrictConfigs } from "@/config/extendedConfigs";
import { faqArticleConfigs } from "@/config/faqConfigs";
import { lifeEventConfigs } from "@/config/lifeEventConfigs";

import { SettingsProvider } from "@/hooks/useSettings";

import CookieConsent from "@/components/common/CookieConsent";
import WhatsAppWidget from "@/components/common/WhatsAppWidget";
import { trackPageView } from "@/utils/tracking";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView();
  }, [pathname]);
  return null;
}

function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Core pages */}
        <Route path="/" element={<HomePage />} />
        <Route path="/immobilie-verkaufen-kreis-mettmann" element={<SellerPage />} />
        <Route path="/immobilie-kaufen-kreis-mettmann" element={<BuyerPage />} />
        <Route path="/marktwertermittlung-kreis-mettmann" element={<MarktWertPage />} />
        <Route path="/kontakt" element={<KontaktPage />} />
        <Route path="/impressum" element={<ImpressumPage />} />
        <Route path="/datenschutz" element={<DatenschutzPage />} />

        {/* SEO Cluster Pages */}
        {Object.entries(seoPageConfigs).map(([slug, config]) => (
          <Route key={slug} path={`/${slug}`} element={<SeoPage config={config} />} />
        ))}

        {/* District / City Pages (Verkaufen) */}
        {Object.entries(districtConfigs).map(([key, config]) => (
          <Route key={key} path={`/immobilie-verkaufen-${config.slug}`} element={<DistrictPage config={config} />} />
        ))}

        {/* Extended SEO Pages */}
        {Object.entries(extendedSeoConfigs).map(([slug, config]) => (
          <Route key={slug} path={`/${slug}`} element={<SeoPage config={config} />} />
        ))}

        {/* Buyer City Pages */}
        {Object.entries(buyerDistrictConfigs).map(([key, config]) => (
          <Route key={key} path={`/immobilie-kaufen-${config.slug}`} element={<BuyerDistrictPage config={config} />} />
        ))}

        {/* FAQ Article Pages */}
        {Object.entries(faqArticleConfigs).map(([slug, config]) => (
          <Route key={slug} path={`/${slug}`} element={<FaqArticlePage config={config} />} />
        ))}

        {/* Immobilienpreise */}
        <Route path="/immobilienpreise-kreis-mettmann" element={<ImmobilienpreisePage />} />

        {/* Ratgeber Overview */}
        <Route path="/ratgeber" element={<RatgeberPage />} />

        {/* Life Event / Ratgeber Pages */}
        {Object.entries(lifeEventConfigs).map(([slug, config]) => (
          <Route key={slug} path={`/${slug}`} element={<LifeEventPage config={config} />} />
        ))}

        {/* Aktuelles (Blog) */}
        <Route path="/aktuelles" element={<BlogPage />} />
        <Route path="/aktuelles/:slug" element={<BlogArticlePage />} />

        {/* Objekte */}
        <Route path="/objekte" element={<ObjektePage />} />
        <Route path="/objekte/:slug" element={<ObjekteDetailPage />} />

        {/* Admin */}
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <BrowserRouter>
          <AppRoutes />
          <WhatsAppWidget />
          <CookieConsent />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#262626",
                color: "#ffffff",
                border: "1px solid rgba(255,255,255,0.1)",
                fontFamily: "Manrope, sans-serif",
              },
            }}
          />
        </BrowserRouter>
      </SettingsProvider>
    </div>
  );
}

export default App;
